import { UserRecord } from "firebase-admin/auth";
import Badge from "../../components/badges/Badges";
import { InfoBoard } from "../../components/infoBoard/InfoBoard";

export type CompaniesProps = {
  value: UserRecord | undefined;
  tenantId: string;
};

export const StaffRef = ({ value, tenantId }: CompaniesProps) => {

  const file: { [key: string]: any } = {
    'メールアドレス': value?.email,
    'メールアドレス認証有無':
      value?.emailVerified === true ? (
        <Badge color="green">承認済み</Badge>
      ) : (
        <Badge color="red">未承認</Badge>
      ),
    '状態':
      value?.disabled === false ? (
        <Badge color="green">有効</Badge>
      ) : (
        <Badge color="red">無効</Badge>
      ),
  };

  return (
    <>
      <div className="flex min-w-0">
        <h2 className="truncate text-2xl font-bold text-gray-900">
          <Badge color="indigo">スタッフ</Badge> {value?.displayName}
        </h2>
      </div>
      <InfoBoard col={"col1"} filed={file} children={undefined} />
    </>
  );
};
